import { ReactNode } from "react";
import { CartButton } from '@/components/cart/CartButton';
import { ProfileMenu } from "@/components/layout/ProfileMenu";
import { Link, Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { AuthDialog } from "@/components/auth/AuthDialog";
import { User, ShoppingCart } from "lucide-react";
import { FeedbackButton } from "./FeedbackButton";

interface LayoutProps {
  children?: ReactNode;
  showNav?: boolean;
  variant?: 'default' | 'landing';
}

const Layout = ({ children, showNav = true, variant = 'default' }: LayoutProps) => {
  const { user } = useAuth();
  const [showAuthDialog, setShowAuthDialog] = useState(false);

  return (
    <div className="min-h-screen flex flex-col">
      {showNav && (
        <header className="bg-white border-b sticky top-0 z-50">
          <div className="container mx-auto px-4 py-3">
            <div className="max-w-7xl mx-auto">
              <nav className="flex justify-between items-center">
                <Link to={user ? "/albums" : "/"} 
                        className="flex items-center gap-2">
                  <img 
                    src="/lovable-uploads/removebg-cut_text.png" 
                    alt="SurfSnap Logo" 
                    className="w-11 h-10"
                  />
                  <span className="text-xl font-bold bg-gradient-to-r from-[#003366] to-[#3498db] bg-clip-text text-transparent">
                    SurfSnap
                  </span>
                </Link>
                
                <div className="flex items-center gap-4">
                  {user ? (
                  <CartButton />
                  ) : (
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => setShowAuthDialog(true)}
                      className="flex items-center gap-2"
                    >
                      <ShoppingCart className="w-4 h-4" />
                      <span>Cart</span>
                    </Button>
                  )}
                  
                  {user ? (
                    <ProfileMenu />
                  ) : (
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => setShowAuthDialog(true)}
                      className="flex items-center gap-2"
                    >
                      <User className="w-4 h-4" />
                      <span>Login</span>
                    </Button>
                  )}
                </div>
              </nav>
            </div>
          </div>
        </header>
      )}

      {variant === 'landing' ? (
        <main className="flex-grow">
          {children}
        </main>
      ) : (
        <main className="flex-grow bg-gray-50">
          <div className="container mx-auto px-4 py-8">
            <div className="max-w-7xl mx-auto">
              <Outlet />
            </div>
          </div>
        </main>
      )}

      <AuthDialog 
        isOpen={showAuthDialog}
        onClose={() => setShowAuthDialog(false)}
        defaultTab="login"
      />
    <FeedbackButton />
    </div>
  );
};

export default Layout;